export const SET_CONTEXT_VARIABLES = 'SET_CONTEXT_VARIABLES';
export const CLEAR_CONTEXT_VARIABLES = 'CLEAR_CONTEXT_VARIABLES';

export default {
  SET_CONTEXT_VARIABLES,
  CLEAR_CONTEXT_VARIABLES,
};
